
export default [
  // {
  //   url: require(`@/assets/fonts/BoschSans-Light.otf`),
  //   name: `BoschSans`,
  //   weight: 200,
  // },
];
